export const loadData_const = 'loadData_const';
export const addNewEmployee_const = 'addNewEmployee_const';
export const deleteAllSelectedEmployees_const = 'deleteAllSelectedEmployees_const';
export const deleteEmployee_const = 'deleteEmployee_const';
export const saveEdit_const = 'oyeeEdit_const';
export const sortEmployees_const = 'sortEmployees_const';
